import { Link } from "react-router-dom";

export default function DiscoverEmptyState({ title, description, ctaLabel, ctaHref, testId = "discover-empty-state" }) {
    return (
        <div className="rounded-[28px] p-8 sm:p-10 text-center" style={{ background: "var(--navy-deep)", border: "1px dashed rgba(255,255,255,0.12)" }} data-testid={testId}>
            <div className="font-serif text-2xl text-white mb-2">{title}</div>
            <p className="text-sm text-white/55 max-w-lg mx-auto leading-relaxed">{description}</p>
            {ctaHref && ctaLabel && (
                <Link to={ctaHref} className="btn-gold text-sm !py-2.5 !px-5 mt-5 inline-flex" data-testid={`${testId}-cta`}>
                    {ctaLabel}
                </Link>
            )}
        </div>
    );
}